/**
 * `round PAY-M`, the founder's decision of 12 September 2026, reading `CN-B`'s
 * settings block: **the platform's means are FIVE** , Orange Money, Wave,
 * Moov Money, Sama Money, virement bancaire , **in that order wherever they
 * are listed**, where `WF-CLI-10` §6 and `payments.payment_settings` knew
 * three. Data first, providers later: Wave's and Sama's connections are a
 * provider round of their own, with the founder's contracts and keys.
 *
 * This is the ONE place the order lives. Every screen that lists means , the
 * buyer's « Paiement », the console's settings block, the séquestre's rows ,
 * reads this tuple and never types the order beside it. The codes are the
 * wire's own (`payments.payment_method`), data and never identifiers
 * (`09-01`).
 */
export const PAYMENT_MEANS = ["orange", "wave", "moov", "sama", "virement"] as const;

export type PaymentMean = (typeof PAYMENT_MEANS)[number];

export const isPaymentMean = (value: string): value is PaymentMean =>
  (PAYMENT_MEANS as readonly string[]).includes(value);

/** The means in the record's order, for a list that came in another. */
export const inRecordOrder = <T extends { readonly code: string }>(means: readonly T[]): T[] =>
  [...means].sort(
    (a, b) =>
      (PAYMENT_MEANS as readonly string[]).indexOf(a.code) -
      (PAYMENT_MEANS as readonly string[]).indexOf(b.code),
  );

/** The means' French, the record's own words (`WF-CLI-10` §6 as amended by `PAY-M`). */
export const PAYMENT_MEAN_LABELS: Readonly<Record<PaymentMean, string>> = {
  orange: "Orange Money",
  wave: "Wave",
  moov: "Moov Money",
  sama: "Sama Money",
  virement: "Virement bancaire",
};
